import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';
import { getOrganizationSchema, getWebSiteSchema } from '../../utils/structuredData';

export default function Home() {
  const structuredData = [
    getOrganizationSchema(),
    getWebSiteSchema()
  ];

  return (
    <div className="bg-[#1c1612] min-h-screen overflow-x-hidden">
      <SEOHead
        title="Studio Asım Mete | İç Mimari Tasarım İstanbul | Gravitas Libera"
        description="Studio Asım Mete, İstanbul'da minimalist ve lüks iç mimari tasarım hizmetleri sunan öncü stüdyo. Ofis, konut ve ticari mekan tasarımında uzman ekibimizle mekânsal formda sessiz otorite yaratıyoruz. İç mimari, uygulama, mekansal dönüşüm ve tasarım danışmanlığı hizmetleri."
        keywords="iç mimari istanbul, mimari tasarım, studio asım mete, gravitas libera, lüks iç tasarım, minimalist mimari, ofis tasarımı, konut tasarımı, ticari mekan tasarımı, iç mimar istanbul, modern iç tasarım, lüks konut tasarımı"
        canonical="/"
        ogImage="/og-image.jpg"
        structuredData={structuredData}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/023be8b7066456bd4f2d90259684e893/2b9e772ea16aa5fb0c263150e6cba6e4.png')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        <div className="relative z-10 text-center px-6 w-full max-w-5xl mx-auto flex flex-col items-center justify-center">
          <div className="space-y-8 md:space-y-10 md:transform md:scale-[0.6] md:origin-center">
            <h1 className="text-[clamp(1.35rem,6.5vw,5rem)] md:text-7xl lg:text-8xl font-bold text-white tracking-[0.12em] md:tracking-[0.2em] leading-tight font-serif text-center whitespace-nowrap">
              STUDIO ASIM METE
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-5xl lg:text-6xl font-light text-white tracking-[0.2em] md:tracking-[0.35em] leading-tight font-serif text-center break-words">
              GRAVITAS LIBERA
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-light tracking-[0.1em] md:tracking-[0.15em] font-serif text-center">
              Sessiz Otoritenin Mekana Yansıması
            </p>
          </div>
          <div className="mt-12 flex items-center justify-center gap-2 text-white animate-bounce">
            <i className="ri-arrow-down-line text-2xl w-6 h-6 flex items-center justify-center"></i>
          </div>
        </div>
      </section>

      {/* Manifesto Section */}
      <section className="py-16 md:py-32 px-6 bg-[#0e0c0a] flex items-center justify-center min-h-[60vh]">
        <div className="max-w-5xl w-full mx-auto text-center space-y-10 md:space-y-12">
          <p className="text-white font-thin leading-[1.9] font-serif tracking-[0.1em] text-base md:text-xl">
            Mekânı dekore etmiyoruz.<br />Pozisyon alıyoruz.
          </p>
          <p className="text-white font-thin leading-[2] font-serif tracking-[0.1em] text-base md:text-xl">
            Her şey konuşuyorsa,<br />hiçbir şey söylenmiyordur.<br />Neyin susacağını biz seçeriz.
          </p>
          <p className="text-white font-thin leading-[2] font-serif tracking-[0.1em] text-base md:text-xl">
            Azaltmak feragat değildir.<br />Kontroldür.
          </p>
        </div>
      </section>

      {/* Selected Work Section */}
      <section className="pt-16 md:pt-32 pb-16 px-6 bg-[#1c1612]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-3xl md:text-4xl font-light text-white tracking-wider mb-4 font-serif uppercase">
              Seçilmiş Çalışmalar
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Link to="/projeler?category=ofis" className="group cursor-pointer">
              <div className="relative h-[280px] sm:h-[380px] md:h-[500px] overflow-hidden rounded-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=luxury%20modern%20office%20interior%20design%20with%20dark%20wood%20furniture%20concrete%20walls%20warm%20ambient%20lighting%20minimalist%20aesthetic%20professional%20workspace%20high%20end%20architecture%20clean%20lines%20sophisticated%20atmosphere&width=600&height=800&seq=office-portfolio-1&orientation=portrait"
                  alt="Ofis Projeleri"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e0c0a]/90 via-[#0e0c0a]/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-2xl font-light text-white tracking-widest font-serif">OFİS</h3>
                </div>
              </div>
            </Link>
            <Link to="/projeler?category=konut" className="group cursor-pointer">
              <div className="relative h-[280px] sm:h-[380px] md:h-[500px] overflow-hidden rounded-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=luxury%20residential%20living%20room%20interior%20with%20modern%20furniture%20concrete%20textures%20warm%20lighting%20minimalist%20design%20high%20end%20architecture%20sophisticated%20atmosphere%20clean%20aesthetic%20neutral%20tones&width=600&height=800&seq=residential-portfolio-1&orientation=portrait"
                  alt="Konut Projeleri"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e0c0a]/90 via-[#0e0c0a]/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-2xl font-light text-white tracking-widest font-serif">KONUT</h3>
                </div>
              </div>
            </Link>
            <Link to="/projeler?category=ticari" className="group cursor-pointer">
              <div className="relative h-[280px] sm:h-[380px] md:h-[500px] overflow-hidden rounded-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=luxury%20commercial%20interior%20space%20with%20modern%20design%20concrete%20walls%20warm%20ambient%20lighting%20minimalist%20aesthetic%20high%20end%20architecture%20sophisticated%20atmosphere%20clean%20lines%20professional%20environment&width=600&height=800&seq=commercial-portfolio-1&orientation=portrait"
                  alt="Ticari Projeler"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e0c0a]/90 via-[#0e0c0a]/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <h3 className="text-2xl font-light text-white tracking-widest font-serif">TİCARİ</h3>
                </div>
              </div>
            </Link>
          </div>
          <div className="text-center mt-14">
            <Link
              to="/projeler"
              className="inline-block border border-[#3d3020] text-white hover:border-white hover:text-white px-10 py-4 text-xs tracking-widest uppercase transition-all duration-300 whitespace-nowrap cursor-pointer font-sans"
            >
              Tüm Projeleri Gör
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Project Section */}
      <section className="pt-16 pb-32 px-6 bg-[#1c1612]">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 md:mb-16">
            <span className="text-xs text-white tracking-widest uppercase font-sans">Öne Çıkan Proje</span>
            <h2 className="text-4xl md:text-5xl font-light text-white tracking-wider mt-4 font-serif">
              Nişantaşı Residence
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            <div className="relative h-[280px] sm:h-[400px] md:h-[560px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=ultra%20luxury%20penthouse%20living%20room%20interior%20Istanbul%20Nisantasi%20dark%20marble%20floors%20floor%20to%20ceiling%20windows%20city%20view%20warm%20golden%20lighting%20minimalist%20furniture%20sophisticated%20high%20end%20residential%20design&width=900&height=900&seq=featured-project-main&orientation=squarish"
                alt="Nişantaşı Residence"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="bg-[#0e0c0a] p-6 md:p-14 flex flex-col justify-between">
              <div>
                <div className="flex flex-wrap gap-4 sm:gap-6 mb-10">
                  <div>
                    <div className="text-xs text-white tracking-widest uppercase mb-1 font-sans">Kategori</div>
                    <div className="text-white font-light font-serif">Konut</div>
                  </div>
                  <div className="w-px bg-[#2a2018]"></div>
                  <div>
                    <div className="text-xs text-white tracking-widest uppercase mb-1 font-sans">Konum</div>
                    <div className="text-white font-light font-serif">İstanbul, TR</div>
                  </div>
                  <div className="w-px bg-[#2a2018]"></div>
                  <div>
                    <div className="text-xs text-white tracking-widest uppercase mb-1 font-sans">Yıl</div>
                    <div className="text-white font-light font-serif">2024</div>
                  </div>
                </div>
                <p className="text-white font-light leading-relaxed text-xl mb-6 font-serif">
                  Nişantaşı&apos;nın kalbinde, 320 m² yaşam alanına sahip bu rezidans; malzeme seçiminden ışık kurgusuna kadar her detayda sessizliğin dilini konuşuyor.
                </p>
                <p className="text-white font-light leading-relaxed font-serif">
                  Koyu mermer zeminler, özel üretim mobilyalar ve şehir manzarasına açılan geniş pencereler — mekân, sahibinin kimliğini değil, duruşunu yansıtıyor.
                </p>
              </div>
              <div className="mt-10">
                <Link
                  to="/projeler"
                  className="inline-flex items-center gap-3 text-white hover:text-white transition-colors duration-300 text-xs tracking-widest uppercase cursor-pointer group font-sans"
                >
                  Projeyi İncele
                  <span className="w-8 h-px bg-[#6b5a45] group-hover:bg-[#c8b89a] group-hover:w-12 transition-all duration-300 inline-block"></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 md:py-32 px-6 bg-[#0e0c0a]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-light text-white tracking-wider mb-10 md:mb-16 font-serif uppercase">
              Çalışma Alanlarımız
            </h2>
            <p className="text-white font-light text-lg sm:text-xl md:text-3xl lg:text-4xl tracking-wide font-sans text-center">
              İç Mimari | Uygulama | Mekânsal Dönüşüm | Tasarım Danışmanlığı
            </p>
          </div>
        </div>
      </section>

      {/* Work Scope Section */}
      <section className="py-16 md:py-32 px-6 bg-[#1c1612]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-20">
            <h2 className="text-4xl md:text-5xl font-light text-white tracking-wider font-serif">
              Yaklaşımımız
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0">
            {[
              { num: '1', title: 'Analiz', desc: 'İhtiyaç, mekânsal potansiyel ve bağlam değerlendirilir.' },
              { num: '2', title: 'Tasarım', desc: 'Kavramsal ve teknik çözümler geliştirilir.' },
              { num: '3', title: 'Uygulama', desc: 'Detay, malzeme ve saha koordinasyonu yönetilir.' },
              { num: '4', title: 'Tamamlanma', desc: 'Mekân, tasarlanan bütünlükle hayata geçirilir.' },
            ].map((item, i) => (
              <div 
                key={item.num} 
                className={`p-8 border-t border-[#2a2018] ${i < 3 ? 'md:border-r border-[#2a2018]' : ''} group hover:bg-[#241e16]/30 transition-colors duration-300`}
              >
                <div className="mb-6">
                  <div className="text-5xl md:text-6xl font-light text-white/20 group-hover:text-white/30 mb-4 transition-colors duration-300 font-serif leading-none">
                    {item.num}
                  </div>
                  <h3 className="text-xl md:text-2xl font-light text-white tracking-wide mb-4 font-serif">
                    {item.title}
                  </h3>
                </div>
                <p className="text-white/80 font-light text-base leading-relaxed font-serif tracking-wider">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-20 md:py-40 px-6 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=dramatic%20dark%20architectural%20interior%20with%20moody%20lighting%20concrete%20textures%20deep%20shadows%20minimal%20furniture%20luxury%20atmosphere%20cinematic%20photography%20high%20contrast%20black%20and%20white%20tones%20sophisticated%20space&width=1920&height=800&seq=cta-bg-section&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-[#0e0c0a]/80"></div>
        </div>
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-6xl font-light text-white tracking-wider mb-8 leading-tight font-serif">
            Bir Projeniz mi Var?
          </h2>
          <p className="text-white font-light text-xl mb-12 leading-relaxed font-serif">
            Mekânınızı birlikte konuşalım. İlk görüşme, her zaman ücretsizdir.
          </p>
          <Link
            to="/iletisim"
            className="inline-block bg-[#c8b89a] text-[#1c1612] px-14 py-5 text-xs tracking-widest uppercase hover:bg-[#b8a88a] transition-colors duration-300 whitespace-nowrap cursor-pointer font-sans"
          >
            İletişime Geç
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
